/** Self-attendance review permission strings (mirror backend PermissionCatalog). */
export const SelfAttendancePermissions = {
  review: 'review_self_attendance',
  /** Review queue or full payroll admins. */
  access: ['review_self_attendance', 'manage_payroll'] as const,
} as const
